import { combineReducers } from 'redux';
import init from './init';
import history from '../../lib/history';
import { connectRouter } from 'connected-react-router';
import authenticateReducer from './authenticate';
import drawerReducer from './drawer';
import loader from './loader';
import responseError from './responseError';
import masterReducer from './onboarding/masters';
import personalReducer from './onboarding/personal';
import orderbook from './orderbook'
import Auth from './trans/authReducer';
import selectedScheme from './selectedScheme';
import etfTransaction from './etfTransaction';

let historyR = !process.env.IS_SERVER ? { router: connectRouter(history) } : {};

export default combineReducers({
  Auth,
  ...historyR,
  init,
  authenticateUser: authenticateReducer,
  isDrawerOpen: drawerReducer,
  responseError,
  loader,
  masterReducer,
  personalReducer,
  orderbook,
  selectedScheme,
  etfTransaction,

})
